import useAxios from 'hooks/useAxios'
import { useRouteMatch } from 'react-router-dom'

function useWorkspace() {
  const match = useRouteMatch()
  const workspaceToken = match.params.workspaceToken

  const { data } = useAxios({
    url: 'account/workspaces/',
    method: 'get',
    skip: !!workspaceToken,
  })

  if (workspaceToken) {
    return workspaceToken
  } else {
    if (data) {
      return data.results[0].workspace_token
    }
  }
}

export default useWorkspace



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useWorkspace/index.js